import {StyleSheet} from 'react-native';

const styles = StyleSheet.create({
  imgAgenda: {
    minHeight: '20vh',
  },
  parent: {
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
  },
  cardContainer: {
    padding: 0,
    width: '100%',
    borderColor: '#f5f5f5',
  },
  hourCard: {
    width: '20%',
    borderColor: '#f5f5f5',
  },
  cardButtonGroup: {
    height: 50,
    width: '90%',
    marginLeft: '5%',
    marginRight: '5%',
  },
  buttonStyle: {
    backgroundColor: '#8a3146',
    borderRadius: 40,
  },
  buttonContainerStyle: {
    width: 80,
    height: 40,
    borderRadius: 40,
    backgroundColor: '#8a3146',
  },
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  loginContainer: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#f7f7f7',
  },
  title: {
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    textAlignVertical: 'center',
    flex: 1,
    fontSize: 30,
    color: '#3b5998',
  },
  scale: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'row',
    textAlign: 'center',
  },
  iconText: {
    flex: 1,
    textAlign: 'center',
  },
  logoName: {
    // height: 50
  },
  startLogo: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  startText: {
    height: 150,
  },
  startButton: {
    width: '50%',
  },
  scrollStyle: {
    flexGrow: 1,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#f5f5f5',
  },
  logo: {
    width: 100,
    height: 100,
    borderRadius: 50,
  },
  logoEleven: {
    width: 300,
    height: 100,
    marginBottom: 10,
    marginLeft: 'auto',
    marginRight: 'auto',
    resizeMode: 'contain',
  },
  slider: {
    flex: 2,
    flexDirection: 'column',
    justifyContent: 'center',
    width: '90%',
  },
  next: {
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'center',
  },
  symptoms: {
    color: '#3b5998',
    fontSize: 14,
    marginTop: 5,
    marginLeft: 10,
    marginRight: 10,
    textAlign: 'center',
  },
  textStyle: {
    fontSize: 22,
  },
  textInputStyle: {
    textAlign: 'center',
    height: 40,
    borderRadius: 10,
    borderWidth: 2,
    borderColor: '#dc812e',
    marginBottom: 10,
  },
  tutorialNextButton: {
    alignItems: 'center',
    justifyContent: 'center',
    height: 40,
    borderRadius: 10,
    backgroundColor: '#dc812e',
  },
  emailText: {
    textAlign: 'center',
    height: 40,
    width: 250,
    borderRadius: 10,
    borderWidth: 2,
    borderColor: '#dc812e',
    marginTop: 5,
  },
  emailButton: {
    marginTop: 5,
    alignItems: 'center',
    justifyContent: 'center',
    height: 40,
    width: 250,
    borderRadius: 10,
    backgroundColor: '#dc812e',
  },
  fbLogin: {
    alignItems: 'center',
    justifyContent: 'center',
    height: 40,
    width: 250,
    borderRadius: 10,
    // borderWidth: 2,
    backgroundColor: '#3b5998',
    // borderColor: '#3b5998',
  },
});

const profileStyles = StyleSheet.create({
  modalityText: {
    textAlign: 'center',
    fontSize: 18,
    fontWeight: 'bold',
  },
  numberText: {
    textAlign: 'center',
    fontSize: 14,
  },
  modalityView: {
    width: '30%',
    marginTop: 20,
  },
  profileName: {
    color: 'white',
    fontSize: 22,
    fontWeight: 'bold',
    marginTop: 30,
  },
  email: {
    color: 'white',
    fontSize: 18,
  },
  avatar: {
    marginTop: 65,
  },
  header: {
    fontSize: 18,
    fontWeight: 'bold',
    textAlign: 'left',
    marginTop: 100,
    width: '100%',
    marginLeft: '10%',
  },
});

export {styles, profileStyles};
